import React from "react";
import BackButton from "./BackButton";
import Breadcrumb from "./Breadcrumb";

export default function PageHeader({
  title,
  eyebrow,
  description,
  actions,
  items = [],
  backTo,
  backStrict = false,
  className = "",
  children,
}) {
  const showBack = backTo === true || typeof backTo === "string";
  const fallbackTo = typeof backTo === "string" ? backTo : undefined;
  const hasCrumbs = Array.isArray(items) && items.length > 0;
  const headerActions = !hasCrumbs ? actions : null;
  const belowActions = hasCrumbs ? actions : null;

  return (
    <>
      <div className="package-catalog-head">
        <div className={`d-flex flex-wrap ${headerActions ? "align-items-start" : "align-items-center"} justify-content-between gap-3 ${children ? "package-catalog-header" : "mb-0"} ${className}`.trim()}>
          <div className="min-w-0">
            {eyebrow ? (
              <div className="text-uppercase text-secondary small fw-semibold mb-1">{eyebrow}</div>
            ) : null}
            {title ? (
              typeof title === "string" ? <h3 className="mb-0">{title}</h3> : title
            ) : null}
            {description ? (
              typeof description === "string" ? (
                <p className="text-secondary small mb-0 mt-2">{description}</p>
              ) : (
                description
              )
            ) : null}
          </div>
          <div className="agent-page-header__meta">
            {showBack ? <BackButton fallbackTo={fallbackTo} strict={backStrict} /> : null}
            {hasCrumbs ? <Breadcrumb items={items} /> : null}
            {headerActions ? <div className="page-head-actions">{headerActions}</div> : null}
          </div>
        </div>
        {children}
      </div>
      {belowActions ? <div className="page-head-actions mb-24">{belowActions}</div> : null}
    </>
  );
}
